export type ShowingStatus = 'requested' | 'confirmed' | 'rescheduled' | 'cancelled';

export type LeadPipelineStatus =
  | 'new'
  | 'showing_scheduled'
  | 'showing_confirmed'
  | 'prospect_invited'
  | 'approved_to_apply'
  | 'lease_created'
  | 'tenant_active'
  | 'lost';

export interface ShowingRequest {
  id: string;
  leadId: string | null;
  propertyId: string;
  propertyCode: string;
  unitId: string;
  unitLabel: string;
  visitorName: string;
  visitorEmail: string;
  visitorPhone: string;
  preferredDate: string;
  preferredTime: string;
  message: string | null;
  status: ShowingStatus;
  pipelineStatus: LeadPipelineStatus;
  createdAt: string;
  updatedAt: string;
}

export interface ShowingAvailabilitySlot {
  time: string;
  status: 'available' | 'booked' | 'blocked';
  note?: string | null;
  showingId?: string | null;
}

export function derivePipelineStatusFromShowing(
  status: ShowingStatus,
  fallback: LeadPipelineStatus = 'new',
): LeadPipelineStatus {
  const preferredStatus: LeadPipelineStatus[] = [
    'showing_scheduled',
    'showing_confirmed',
    'prospect_invited',
    'approved_to_apply',
    'lease_created',
    'tenant_active',
    'lost',
  ];

  switch (status) {
    case 'requested':
      return 'showing_scheduled';
    case 'confirmed':
    case 'rescheduled':
      if (preferredStatus.includes(fallback)) {
        return fallback;
      }
      return 'showing_confirmed';
    case 'cancelled':
      return fallback;
    default:
      return fallback;
  }
}
